import React, { useMemo, useState, useEffect } from 'react';
import InputField from '../InputField';
import { InputFieldProps } from '../InputField/InputField.component';
import { useTranslation } from 'react-i18next';
import api from 'api';

type AbcAbnTypes = 'ABN' | 'ABC';

type AbnAcnFieldProps = {
  numberType: AbcAbnTypes;
  listingId: string;
} & InputFieldProps;

const AbnAcnField: React.FC<AbnAcnFieldProps> = (props) => {
  const {
    numberType,
    required,
    listingId,
    input: { value, ...restInput },
    meta: { touched, error, ...restMeta },
    ...rest
  } = props;
  const { t } = useTranslation();
  const [fetchedError, setFetchedError] = useState('');
  const hasError = useMemo(() => touched && error, [error, touched]);

  const isAbn = useMemo(() => numberType === 'ABN', [numberType]);

  useEffect(() => {
    if (hasError || !value || !listingId) return;

    (async () => {
      try {
        const {
          data: { exist },
        } = await api.listings[isAbn ? 'checkABN' : 'checkACN'](
          listingId,
          value,
        );
        if (exist) {
          setFetchedError(`${isAbn ? 'abn' : 'acn'}AlreadyExists`);
        } else {
          setFetchedError('');
        }
      } catch (e) {
        return 'serverValidationFailed';
      }
    })();
  }, [hasError, isAbn, listingId, value]);

  const newMeta = useMemo(
    () => ({ touched, error: error || fetchedError, ...restMeta }),
    [error, fetchedError, restMeta, touched],
  );

  return (
    <InputField
      label={t(isAbn ? 'abnForListing' : 'acnForListing')}
      type="number"
      placeholder={t(isAbn ? 'mustBe11' : 'mustBe9')}
      required={required ?? true}
      meta={newMeta}
      input={{ value, ...restInput }}
      {...rest}
    />
  );
};

export default AbnAcnField;
